import { z } from 'zod';
export const sectionTypeSchema = z.enum([
    'ScheduleOfActivities',
    'Text',
    'Title',
    'StudyDesign',
    'Population',
    'ObjectivesAndEndpoints',
    'Interventions',
    'InterventionGroups',
]);
//# sourceMappingURL=section-type.js.map